var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.848632 4.17432L0.424368 4.59858L0.000103885 4.17432L0.424368 3.75005L0.848632 4.17432ZM4.59863 13.0243C4.26726 13.0243 3.99863 12.7557 3.99863 12.4243C3.99863 12.0929 4.26726 11.8243 4.59863 11.8243L4.59863 12.4243L4.59863 13.0243ZM4.59863 7.92432L4.17437 8.34858L0.424368 4.59858L0.848632 4.17432L1.2729 3.75005L5.0229 7.50005L4.59863 7.92432ZM0.848632 4.17432L0.424368 3.75005L4.17437 5.21613e-05L4.59863 0.424316L5.0229 0.84858L1.2729 4.59858L0.848632 4.17432ZM0.848632 4.17432L0.848632 3.57432L8.72363 3.57432L8.72363 4.17432L8.72363 4.77432L0.848632 4.77432L0.848632 4.17432ZM8.72363 12.4243L8.72363 13.0243L4.59863 13.0243L4.59863 12.4243L4.59863 11.8243L8.72363 11.8243L8.72363 12.4243ZM12.8486 8.29932L13.4486 8.29932C13.4486 10.9089 11.3332 13.0243 8.72363 13.0243L8.72363 12.4243L8.72363 11.8243C10.6704 11.8243 12.2486 10.2461 12.2486 8.29932L12.8486 8.29932ZM8.72363 4.17432L8.72363 3.57432C11.3332 3.57432 13.4486 5.68977 13.4486 8.29932L12.8486 8.29932L12.2486 8.29932C12.2486 6.35251 10.6704 4.77432 8.72363 4.77432L8.72363 4.17432Z",
    fill: "#364153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoSelected);
export default __webpack_public_path__ + "static/media/undo_selected.ddafbb5742a5310f30cd37383b4cf5e8.svg";
export { ForwardRef as ReactComponent };